<template>
    <edit-dialog title="Changelog aanpassen" @open="open" @close="close" :loading="loading" :event="update">
        <Fields v-if="!loading" v-model="editChangelog" :validations="$v.editChangelog" />

        <template v-slot:button="{ on, attrs }">
            <v-btn small
                   v-on="on"
                   v-bind="attrs"
                   color="primary"
            >
                <v-icon small class="mr-2">mdi-pencil</v-icon>
                Edit changelog
            </v-btn>
        </template>
    </edit-dialog>
</template>
s
<script>
import User from "@/models/User/User";
import Fields from "@/components/Changelog/Fields.vue";
import {required} from "vuelidate/lib/validators";
import Changelog from "@/models/Changelog/Changelog";
import EditDialog from "@/components/General/Dialog/EditDialog.vue";

export default {
    components: {
        EditDialog,
        Fields,
    },
    props: {
        id: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            editChangelog: {},
            dialog: false,
            loading: false,
        }
    },
    validations: {
        editChangelog: {
            version: {
                required,

            },
            content: {
                required,
            }
        }
    },
    computed: {
        currentUser() {
            return User.loggedInUser();
        },
    },
    methods: {
        update() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                return Changelog.api().updateById(this.id, this.editChangelog, true).then(() => {
                    this.$emit('changelogChanged');
                    this.dialog = false;
                });
            }
        },
        close() {
            this.$v.$reset();
            this.editChangelog = {};
            this.dialog = false;
        },
        open() {
            this.loading = true;
            Changelog.api().with([]).find(this.id).then(changelog => {
                this.editChangelog.id = changelog.id;
                this.editChangelog.version = changelog.version;
                this.editChangelog.content = changelog.content;
                this.loading = false;
            });
        },
    },
}
</script>
